import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingClientIdentification } from 'cloud-shared-lib';
import { Observable } from 'rxjs';

@Injectable()
export class LoginService {
  constructor(private http: HttpClient) {}

  login(
    email: string,
    password: string,
    userId: number,
    lang: string,
    md5Pass = false
  ): Observable<CuttingClientIdentification> {
    const paramsHttp: HttpParams = new HttpParams().set('lang', lang).set('md5Pass', md5Pass);

    return this.http.post<CuttingClientIdentification>(
      ApiLinks.login,
      { login: email, password: password, userId: userId },
      { params: paramsHttp }
    );
  }
}
